import API from '@/lib/API.js'
import comun from './comun.js'
const imagenespracticas = {
    namespaced: true,
    state: {
        Lista: [],
        Filtradas: [],
        Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state.Filtradas= [];
            state.Seleccionado = undefined;
        },
        set(state, payload) {
            state.Lista = payload;
        },
        select(state, payload) {
            state.Seleccionado = payload;
        },
    },
    actions: {
        async setPorIdImagenes({
            commit,
        }, idImagenes) {
            commit("comun/cargando")
            commit("set", [])
            let data = await API.ImagenesPracticas.traerPorIdImagenes(idImagenes);
            commit("set", data)
            commit("comun/fincarga")
        },
        set({
            commit
        }, payload) {
            commit("set", payload)
        },
        select({
            commit
        }, payload) {
            commit("select", payload)
        },
        selectPorId({
            commit,
            state
        }, payload) {
            commit("comun/cargando")
            let entidad = state.Lista.find((x) => x.id_documentacion_afiliado == payload)
            commit("select", entidad)
            commit("comun/fincarga")
        },
        setNuevo({
            commit
        }) {
            commit("comun/cargando")
            let entidad = {
                id_documentacion_afiliado: 0,
                id_tipo_documentaciones: 0,
                id_afiliado: 0,
                fecha_carga: '',
                nombre_documento: '',
                url_carpeta: '',
                id_usuario_carga: 0,
            }
            commit("select", entidad)
            commit("comun/fincarga")
        },
        async guardar({
            commit,
            dispatch,
            state
        }) {
            let data = []
            let str = ""
            if (state.Seleccionado.id_documentacion_afiliado != 0) {
                data = await API.ImagenesPracticas.modificar(state.Seleccionado);
                str += "Imagen modificada"
            } else {
                data = await API.ImagenesPracticas.alta(state.Seleccionado);
                str += `Nueva Imagen de alta`
            }
            let entidades = await API.ImagenesPracticas.traerTodos();
            commit("set", entidades)
            dispatch("selectPorId", data.id_documentacion_afiliado)
            commit("comun/mostrar", str)
        },
        async guardarEntidad({
            commit,
            dispatch
        }, entidad) {
            let data = []
            let str = ""
            if (entidad.id_documentacion_afiliado != 0) {
                data = await API.ImagenesPracticas.modificar(entidad);
                str += "Imagen modificada"
            } else {
                data = await API.ImagenesPracticas.alta(entidad);
                str += `Nueva Imagen de alta`
            }
            let entidades = await API.ImagenesPracticas.traerTodos();
            commit("set", entidades)
            dispatch("selectPorId", data.id_documentacion_afiliado)
            commit("comun/mostrar", str)
        },
    },
    modules: {
        comun,
    }
}
export default imagenespracticas;